import React, { useState } from 'react';
import { Formatter } from '../helpers/formatter.js'
import '../styles/Form.css';
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";


const schema = yup.object().shape({
    imie: yup.string().required("Podaj imię."),
    nazwisko: yup.string().required("Podaj nazwisko."),
    mail: yup.string().email("Wprowadź poprawny adres e-mail.").required("Podaj adres e-mail."),
    dom: yup.string().required("Podaj numer domu."),
    miasto: yup.string().required("Podaj nazwe miejscowości."),
    kodPoczt: yup.string().required("Podaj kod pocztowy."),
    regulamin: yup.boolean().oneOf([true], "Musisz zaakceptować regulamin.")
});

const CustomerForm = (props) => {
    const query = new URLSearchParams(window.location.search);
    const [pesel, setPesel] = useState(query.get('peselInput'));
    const [validPesel, setValidPesel] = useState(false);

    const totalPrice = (props.parentData.reduce((a, v) => a = a + v.price, 0));
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });
    const regulamin = JSON.parse(window.localStorage.getItem('regulamin'));

    function handleChange(event) {
        const { value } = event.target
        setPesel(value)
        validatePesel(value)
    };

    function validatePesel(pesel) {
        let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
        let sum = 0;
        let controlNumber = parseInt(pesel.substring(10, 11));
        for (let i = 0; i < weight.length; i++) {
            sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
        }
        sum = sum % 10;
        if ((10 - sum) % 10 !== controlNumber) {
            setValidPesel(true)
        } else if ((10 - sum) % 10 === controlNumber) {
            setValidPesel(false)
        }
        if (pesel === '') {
            setValidPesel(null)
        }
    };

    const submitForm = (data) => {
        document.getElementById("myForm").submit();
        document.getElementById("myForm").reset();
        console.log(data);
    }


    return (

        <div className="p-2">
            <section className="content-header">
                <h2>
                    Wypełnij dane
                </h2>
            </section>
            <form onSubmit={handleSubmit(submitForm)} id="myForm" action="./../bm/ruo.php" method="POST" className="p-3">
                <div className="form-row">
                    <div className="form-group col-md-3">
                        <label className="form-label red-dot" htmlFor="imieInput">&nbsp;Imię:</label>
                        <input type="text" name="imie" className="form-control" {...register('imie')} id="imieInput" defaultValue={query.get('imieInput')} />
                        <small style={{ color: "red" }}> {errors.imie?.message} </small>
                    </div>
                    <div className="form-group col-md-3">
                        <label className="form-label red-dot" htmlFor="nazwiskoInput">&nbsp;Nazwisko:</label>
                        <input type="text" name="nazwisko" {...register('nazwisko')} className="form-control" id="nazwiskoInput" defaultValue={query.get('nazwiskoInput')} />
                        <small style={{ color: "red" }}> {errors.nazwisko?.message} </small>
                    </div>
                    <div className="form-group col-md-3">
                        <label className="form-label red-dot" htmlFor="mailInput">&nbsp;Adres mailowy:</label>
                        <input type="text" name="mail" {...register('mail')} className="form-control" placeholder="@" id="mailInput" defaultValue={query.get('mailInput')} />
                        <small style={{ color: "red" }}> {errors.mail?.message} </small>

                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-3">
                        <label className="form-label" htmlFor="ulicaInput">&nbsp;Ulica:</label>
                        <input type="text" name="ulica" className="form-control" id="ulicaInput" defaultValue={query.get('ulicaInput')} />
                    </div>
                    <div className="form-group col-md-2">
                        <label className="form-label red-dot" htmlFor="domInput">&nbsp;Numer domu:</label>
                        <input type="text" name="dom" {...register('dom')} className="form-control" id="domInput" defaultValue={query.get('domInput')} />
                        <small style={{ color: "red" }}> {errors.dom?.message} </small>

                    </div>
                    <div className="form-group col-md-2">
                        <label className="form-label" htmlFor="mieszkanieInput">&nbsp;Numer mieszkania:</label>
                        <input type="text" className="form-control" name="mieszkanie" id="mieszkanieInput" defaultValue={query.get('mieszkanieInput')} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-3">
                        <label className="form-label red-dot" htmlFor="miastoInput">&nbsp;Miasto:</label>
                        <input type="text" name="miasto" {...register('miasto')} className="form-control" id="miastoInput" defaultValue={query.get('miastoInput')} />
                        <small style={{ color: "red" }}> {errors.miasto?.message} </small>

                    </div>
                    <div className="form-group col-md-3">
                        <label className="form-label red-dot" htmlFor="kodPocztInput">&nbsp;Kod Pocztowy:</label>
                        <input type="text" name="kodPoczt" {...register('kodPoczt')} className="form-control" id="kodPocztInput" defaultValue={query.get('kodPocztInput')} />
                        <small style={{ color: "red" }}> {errors.kodPoczt?.message} </small>

                    </div>
                    <div className="form-group col-md-3">
                        <label className="form-label" htmlFor="peselInput">&nbsp;PESEL:</label>
                        <input type="text" className="form-control" name="pesel" {...register('pesel')} maxLength={11} id="peselInput" onChange={handleChange} defaultValue={query.get('peselInput')} />
                        {validPesel && pesel.length === 11 ? <small style={{ color: "red" }}>Błędny numer PESEL.</small> : null}
                    </div>
                </div>
                {regulamin ? <div className="form-group">
                    <div className="form-check">
                        <input className="form-check-input" name="regulamin" {...register('regulamin')} type="checkbox" id="gridCheck" />
                        <label className="form-check-label" htmlFor="gridCheck"><p className="red-dot">Zaakceptuj <a href="regulamin.pdf" target="_blank">regulamin</a> i politykę prywatności.</p></label>
                    </div>
                    <small style={{ color: "red" }}> {errors.regulamin?.message} </small>
                </div> : null}

                <p className="red-dot">&nbsp;Pola oznaczone gwiazdką są obowiązkowe.</p>
                <strong>Podsumowanie</strong>
                <div className="card m-2">
                    {(props.parentData.length > 0) ? props.parentData.map((charge, charge_index) => {
                        return (
                            <div key={charge.id} className="d-flex bd-highlight">
                                <div className="p-2 flex-grow-1 bd-highlight">
                                    <label className="form-check-label">{charge.name}</label>
                                </div>
                                <div className="p-2 bd-highlight">{Formatter.toCurrency(charge.price)}</div>
                            </div>
                        )
                    }) : ""}
                    <div className="d-flex bd-highlight">

                        <div className="p-2 flex-grow-1 bd-highlight">
                            <label className="form-check-label"><b>Razem</b></label>
                        </div>
                        <div className="p-2"><b>{Formatter.toCurrency(totalPrice)}</b></div>
                    </div>

                </div>
                <input id="totalPrice" name="totalPrice" type="hidden" value={totalPrice}></input>
                <input id="cart" name="cart" type="hidden" value={JSON.stringify(props.parentData)}></input>
                <button className="btn btn-primary" type="submit" >Zapłać</button>
            </form>
        </div >
    );
}

export default CustomerForm;